export const ENVIRONMENT = false;

export const INTERVIEW_AI_URL = ENVIRONMENT
  ? "https://interview-api.lapieza.io"
  : "https://interview-api-dev.lapieza.io";

export const INTERVIEW_AI_SOCKET_URL = ENVIRONMENT
  ? "wss://interview-api.lapieza.io"
  : "wss://interview-api-dev.lapieza.io";
